// @unocss-include
const layout = () => import('@/layout/index.vue')
const routes = [
  {
    path: '/reports',
    name: 'Reports',
    component: layout,
    redirect: '/reports/index',
    meta: {
      title: '定制报告',
      i18Key: 'router.user.reports.title',
      roles: [1],
      category: 'optimize'
    },
    sort: 0,
    children: [
      {
        path: 'index',
        name: 'ReportsIndex',
        component: () => import('@/views/Reports/Index.vue'),
        meta: {
          title: '定制报告',
          icon: 'i-menu:report',
          i18Key: 'router.user.reports.index',
          roles: [1],
          headerConditions: ['brand']
        }
      },
      {
        path: 'historyList',
        name: 'HistoryList',
        hiddenInMenu: true,
        component: () => import('@/views/Reports/HistoryList/Index.vue')
      },
      {
        path: 'templates',
        name: 'TemplateAll',
        hiddenInMenu: true,
        component: () => import('@/views/Reports/TemplateAll/Index.vue'),
        meta: {
          roles: [1],
          headerConditions: ['brand']
        }
      },
      {
        path: 'chat/:id',
        name: 'ReportsChat',
        hiddenInMenu: true,
        meta: {
          headerConditions: ['brand']
        },
        roles: [1],
        component: () => import('@/views/Reports/Chat/Index.vue')
      }
    ]
  },
  {
    path: '/library',
    name: 'Library',
    component: layout,
    redirect: '/library/index',
    meta: {
      title: '品牌语料库',
      i18Key: 'router.user.library.title',
      roles: [1],
      category: 'optimize',
      headerConditions: ['brand']
    },
    sort: 10,
    children: [
      {
        path: 'index',
        name: 'LibraryIndex',
        component: () => import('@/views/Library/Index.vue'),
        meta: {
          title: '品牌资料库',
          icon: 'i-menu:library',
          i18Key: 'router.user.library.index',
          roles: [1]
        }
      }
    ]
  }
]
export default routes
